module.exports = __webpack_public_path__ + "images/emoji/telescope.155384ee6f811497ef9c.png";